var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0574 5.80752C2.11545 5.74931 2.18442 5.70314 2.26035 5.67163C2.33629 5.64012 2.41769 5.6239 2.4999 5.6239C2.58211 5.6239 2.66351 5.64012 2.73944 5.67163C2.81537 5.70314 2.88434 5.74931 2.9424 5.80752L9.9999 12.8663L17.0574 5.80752C17.1155 5.74941 17.1845 5.70331 17.2604 5.67186C17.3363 5.64042 17.4177 5.62423 17.4999 5.62423C17.5821 5.62423 17.6635 5.64042 17.7394 5.67186C17.8153 5.70331 17.8843 5.74941 17.9424 5.80752C18.0005 5.86563 18.0466 5.93461 18.0781 6.01054C18.1095 6.08646 18.1257 6.16784 18.1257 6.25002C18.1257 6.3322 18.1095 6.41357 18.0781 6.4895C18.0466 6.56542 18.0005 6.63441 17.9424 6.69252L10.4424 14.1925C10.3843 14.2507 10.3154 14.2969 10.2394 14.3284C10.1635 14.3599 10.0821 14.3761 9.9999 14.3761C9.91769 14.3761 9.83629 14.3599 9.76036 14.3284C9.68442 14.2969 9.61545 14.2507 9.5574 14.1925L2.0574 6.69252C1.99919 6.63446 1.95301 6.56549 1.92151 6.48956C1.89 6.41363 1.87378 6.33223 1.87378 6.25002C1.87378 6.16781 1.89 6.08641 1.92151 6.01048C1.95301 5.93454 1.99919 5.86558 2.0574 5.80752Z",
    fill: "#8D9AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.0bcf9bc1029ccf167a650f8e36b087bb.svg";
export { ForwardRef as ReactComponent };